export function catalogCoverImage(url: string | null | undefined, type: 'artist' | 'song') {
  if (!url?.trim()) {
    return type === 'artist' ? '/assets/defaultImage/artist_default.webp' : '/assets/defaultImage/cover_default.webp';
  }

  if (url.includes('default_avatar_300.png')) {
    return '/assets/defaultImage/artist_default.webp';
  }

  if (url.includes('default_cover_image.png')) {
    return '/assets/defaultImage/cover_default.webp';
  }

  return url;
}
